import { createSelector } from 'reselect';

const selectPlanTemplates = (state: any) => state.planTemplates;


export const selectPlanTemplatesCurrentItem = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.current);

export const selectPlanTemplatesListItems = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectPlanTemplatesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPlanTemplatesQueryItems = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.query);

export const selectPlanTemplatesCreatedItem = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.create);

export const selectPlanTemplatesUpdatedItem = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.update);

export const selectPlanTemplatesReadItem = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.read);

export const selectPlanTemplatesDeletedItem = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.delete);

export const selectPlanTemplatesSearchedItems = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.search);

export const selectPlanTemplatesItemsCount = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.count);

export const selectPlanTemplatesItemsFilter = createSelector([selectPlanTemplates], (planTemplates) => planTemplates.filter);